<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs6>
        <v-layout column>
          <v-flex>
            <v-toolbar>
              <v-toolbar-title>Report Templates</v-toolbar-title>
            </v-toolbar>
            <v-card height=80 v-for="(template) in tempaltes" :key="template.template" ripple>
              <v-list>
                <v-card-text>
                  <v-list-item v-model="selectedTemplates" multiple :value="template"
                    @click="selectedTemplateEdit(template)">
                    <template>
                      <v-card-actions>
                        <v-item-group>
                          {{template.title}}<br>
                          <span class="grey--text">{{template.description}}</span>
                        </v-item-group>
                      </v-card-actions>
                    </template>
                  </v-list-item>
                </v-card-text>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs6>
        <v-layout column>
          <v-flex>
            <v-toolbar>
              <v-toolbar-title>Selected Templates</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn icon :disabled="isSelectedTemplateEmpty" @click="insertOrUpdateData">
                <v-icon>save</v-icon>
              </v-btn>

              <v-btn icon :disabled="isSelectedTemplateEmpty || !templateExists" @click="deleteTemplate">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card>
              <v-list>
                <v-list-item v-if="templateLoading">
                  <v-list-item-content>
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-list-item-content>
                </v-list-item>
                <v-card v-for="(item, index) in selectedTemplates" :key="item.title"
                  @mouseenter="hoverItem = item.title">
                  <v-layout>
                    <v-flex>
                      <v-card-text>
                        <div class="selectedTemp">
                          <v-list-item pa-0>
                            {{item.title}}
                          </v-list-item>
                        </div>
                      </v-card-text>
                    </v-flex>

                    <v-flex md3>
                      <v-card-action v-if="hoverItem === item.title">
                        <v-btn fab small class="ml-2" @click="array_move(selectedTemplates, index, index - 1)">
                          <v-icon>
                            arrow_upward
                          </v-icon>
                        </v-btn>

                        <v-btn fab small class="ml-2" @click="array_move(selectedTemplates, index, index + 1)">
                          <v-icon>
                            arrow_downward
                          </v-icon>
                        </v-btn>

                        <v-btn fab small class="ml-2" @click="selectedTemplates.splice(index, 1)">
                          <v-icon>
                            close
                          </v-icon>
                        </v-btn>
                      </v-card-action>
                    </v-flex>
                  </v-layout>
                </v-card>
                <v-list-item v-if="isSelectedTemplateEmpty">
                  <v-list-item-content>
                    <v-list-item-title v-text="message" color="gray"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  mapGetters,
  mapMutations
} from 'vuex'
import Report from '../services/customReportConfig';

export default {
  data: () => ({
    settings: [],
    hoverItem: '',
    selectedTemplates: [],
    tempaltes: [],
    templateExists: false,
    message: 'No template for selected plant',
    templateLoading: false
  }),
  computed: {
    ...mapGetters(['getSelectedPlantId']),
    isSelectedTemplateEmpty() {
      return this.selectedTemplates.length === 0
    }
  },
  mounted() {
    this.fetchData()
    this.fetchTemplate()
  },
  methods: {
    ...mapMutations([
      'SET_SHOW_SNACKBAR', 
      'SET_SNACKBAR_CONTENT'
    ]),
    updateSnackbar(payload) {
      this.SET_SHOW_SNACKBAR(true)
      this.SET_SNACKBAR_CONTENT(payload)
    },
    selectedTemplateEdit(template) {
      let templateExists = this.selectedTemplates.some((s) => {
        return s.title == template.title
      })
      if(templateExists == true) {
        let tempSelectedTemplate = this.selectedTemplates.filter((tem) => {
          return tem.title != template.title
        })
        this.selectedTemplates = tempSelectedTemplate
      } else {
        this.selectedTemplates.push(template)
      }
    },
    fetchData() {
      Report.fetchTemplates().then(response => {
        console.log(response.data, 'TEMPLATES')
        this.tempaltes = [...response.data]
      }).catch(err => {
        console.log(err, 'ERROR in fetchData')
      })
    },
    insertOrUpdateData() {
      if (this.templateExists) {
        Report.updateTemplates({
          id: this.getSelectedPlantId,
          reports: this.selectedTemplates.map(item => item.template)
        }).then(() => {
          this.updateSnackbar({
            icon: 'success',
            message: 'Template is successfully updated'
          })
        }).catch(() => {
          this.updateSnackbar({
            icon: 'error',
            message: 'There was some issue while making the change'
          })
        })
      } else {
        Report.insertTemplates({
          id: this.getSelectedPlantId,
          reports: this.selectedTemplates.map(item => item.template)
        }).then(() => {
          this.updateSnackbar({
            icon: 'success',
            message: 'Template is successfully created'
          })
        }).catch(() => {
          this.updateSnackbar({
            icon: 'error',
            message: 'There was some issue while making the change'
          })
        })
        this.templateExists = true
      }
    },
    deleteTemplate() {
      Report.deleteTemplate(this.getSelectedPlantId).then(() => {
        this.selectedTemplates = []
        this.templateExists = false
        this.updateSnackbar({
          icon: 'success',
          message: 'Template has been deleted'
        })
      }).catch(err => {
        this.updateSnackbar({
          icon: 'error',
          message: 'There was some issue while making the change'
        })
      })
    },
    fetchTemplate() {
      this.templateLoading = true
      Report.fetchPlantTemplate(this.getSelectedPlantId)
        .then(response => {
          this.templateLoading = false
          if (response.status === 200) {
            this.selectedTemplates = response.data.list.map(item => {
              const keys = this.tempaltes.map(x => x.template)
              return this.tempaltes[keys.indexOf(item.template)]
            })
            this.templateExists = true
          }
        })
        .catch(err => {
          this.templateLoading = false

          this.selectedTemplates = []
          this.templateExists = false
          if (err.response.status === 404) {
            this.message = 'No template for selected plant'
          } else {
            this.message = 'There was an error loading the template. Please try again.'
          }
        })
    },
    array_move(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; 
    }
  },
  watch: {
    getSelectedPlantId() {
      this.fetchTemplate(this.getSelectedPlantId)
    }
  }
}
</script>

<style>
  .active-item {
    background: red;
  }
  .selectedTemp {
    height: 100%;
    padding: 8px 12px 0px;
  }
</style>
